export default __webpack_public_path__ + "static/media/promotion_banner_m.75902232.png";